<template>
  <div class="content-top-padding padding-for-footer bg-img" v-cloak>
    <div class="container mt-5">
      <div
        class="
          row
          routing
          d-flex
          justify-content-between
          align-items-center
          mb-5
        "
      >
        <div class="col main-theme d-flex flex-row align-items-center">
          <router-link :to="{ name: 'ED' }" class="">
            <img class="mr-2 route-arrow" src="@/assets/01/btn_catalog_arrow_l.svg" />
          </router-link>
          <router-link :to="{ name: 'ED' }" class="">
            {{ $t("title.ED") }}
          </router-link>
        </div>
        <div class="col main-theme d-flex justify-content-end text-right align-items-center">
          <router-link :to="{ name: 'SupportToEconomy' }" class="">
            {{ $t("title.supportToEcon") }}
          </router-link>
          <router-link :to="{ name: 'SupportToEconomy' }" class="">
            <img class="ml-2 route-arrow" src="@/assets/01/btn_catalog_arrow_r.svg" />
          </router-link>
        </div>
      </div>

      <div class="row d-flex flex-column mb-5">
        <div class="col">
          <h3 class="main-theme text-uppercase font-weight-bold">{{ $t("title.bms") }}</h3>
        </div>
        <div class="col text-theme" v-if="$i18n.locale == 'zh'">截至2021年10月在任的成員</div>
        <div class="col text-theme" v-else>AS AT OCTOBER 2021</div>
      </div>
    </div>

    <BoardMembersFrame :boardMembers="ZhBoardMembers" v-if="$i18n.locale == 'zh'" />
    <BoardMembersFrame :boardMembers="boardMembers" v-else />

    <div class="container notes text-theme">
      <div class="row mb-5">
        <div class="col" v-if="$i18n.locale == 'zh'">
          註：<br />
          截至2021年3月31日止年度內曾經在任的旅發局成員如下：陳覺威先生於2020年7月18日離任；唐偉邦先生於2020年8月15日離任；楊碧瑤女士於2020年10月31日離任；胡文新先生於2020年12月31日離任；余葉嘉莉女士於2021年7月31日離任。
        </div>
        <div class="col" v-else>
          Notes:<br />
          The following members also served the Board during the year ended 31 March 2021: Mr Victor
          Chan retired on 18 July 2020; Mr James Tong retired on 15 August 2020; Ms Belinda Yeung
          retired on 31 October 2020; Mr Thomas Wu retired on 31 December 2020; Ms Carrie Yu retired
          on 31 July 2021.
        </div>
      </div>
    </div>

    <div class="container">
      <div
        class="
          row
          routing
          d-flex
          justify-content-between
          align-items-center
          mb-5
        "
      >
        <div class="col main-theme d-flex flex-row align-items-center">
          <router-link :to="{ name: 'ED' }" class="">
            <img class="mr-2 route-arrow" src="@/assets/01/btn_catalog_arrow_l.svg" />
          </router-link>
          <router-link :to="{ name: 'ED' }" class="">
            {{ $t("title.ED") }}
          </router-link>
        </div>
        <div class="col main-theme d-flex justify-content-end text-right align-items-center">
          <router-link :to="{ name: 'SupportToEconomy' }" class="">
            {{ $t("title.supportToEcon") }}
          </router-link>
          <router-link :to="{ name: 'SupportToEconomy' }" class="">
            <img class="ml-2 route-arrow" src="@/assets/01/btn_catalog_arrow_r.svg" />
          </router-link>
        </div>
      </div>
    </div>
    <BackToTopBtn />
  </div>
</template>

<script>
import BoardMembersFrame from "@/components/BoardMembers/BoardMembersFrame.vue";
import BackToTopBtn from "@/components/BackToTopBtn.vue";

export default {
  name: "BoardMembers",
  components: { BoardMembersFrame, BackToTopBtn },
  metaInfo: {
    title: "Board Members",
    titleTemplate: "%s - HKTB Annual Report 2020/21",
  },
  methods: {},
  data() {
    return {
      boardMembers: [],
      ZhBoardMembers: [],
    };
  },
  created() {
    this.boardMembers = [
      {
        portrait: "boardmembers/member01.png",
        title: "Dr Pang Yiu-Kai, GBS, JP",
        subtitle: "Chairman & Chairman of QTS Committee",
        notes: ["Deputy Managing Director", "Jardine Matheson Limited"],
      },
      {
        portrait: "boardmembers/member02.png",
        title: "Vivian Sum, JP",
        subtitle: "Deputy Chairman",
        notes: [
          "Commissioner for Tourism ",
          "Commerce and Economic Development Bureau",
          "The Government of the Hong Kong SAR",
        ],
      },
      {
        portrait: "boardmembers/member03.png",
        title: "Abraham Chan, SC",
        subtitle: "",
        notes: ["Barrister – Senior Counsel", "Temple Chambers"],
      },
      {
        portrait: "boardmembers/member04.png",
        title: "Fong Lik-sun",
        subtitle: "",
        notes: ["Director", "Hong Kong Swimming Academy Ltd."],
      },
      {
        portrait: "boardmembers/member05.png",
        title: "Margaret Fong",
        subtitle: "",
        notes: ["Executive Director", "Hong Kong Trade Development Council"],
      },
      {
        portrait: "boardmembers/member06.png",
        title: "Dr Allen Fung",
        subtitle: "",
        notes: ["Executive Director", "Sun Hung Kai Properties Limited"],
      },
      {
        portrait: "boardmembers/member07.png",
        title: "Mary Huen",
        subtitle: "",
        notes: [
          "Executive Director and Chief Executive Officer, Hong Kong",
          "Standard Chartered Bank (Hong Kong) Limited",
        ],
      },
      {
        portrait: "boardmembers/member08.png",
        title: "Rebecca Kwan",
        subtitle: "",
        notes: [
          "Senior Vice President of Sales – HK & UK",
          "Head of Operations – Europe",
          "General Manager  – Lan Kwai Fong Hotel @ Kau U Fong",
          "Dorsett Hospitality International",
        ],
        info: "Appointment effective from 19 July 2020",
      },
      {
        portrait: "boardmembers/member09.png",
        title: "Alice Kwok",
        subtitle: "Chairman of Staff and Finance Committee",
        notes: ["Chief Editor", "Hong Kong Economic Journal Co. Ltd."],
      },
      {
        portrait: "boardmembers/member10.png",
        title: "Lavinia Lau",
        subtitle: "",
        notes: ["Director Commercial", "Cathay Pacific Airways Limited"],
        info: "Appointment effective from 16 August 2020",
      },
      {
        portrait: "boardmembers/member11.png",
        title: "Clarence Leung, BBS, JP",
        subtitle: "Chairman of Product and Event Committee",
        notes: ["Director", "Sun Hing Knitting Factory Ltd."],
      },
      {
        portrait: "boardmembers/member12.png",
        title: "Jason Shum",
        subtitle: "Chairman of Audit Committee",
        notes: ["Director", "Nan Hwa (Express) Travel Service Limited"],
      },
      {
        portrait: "boardmembers/member13.png",
        title: "Ricky Szeto",
        subtitle: "",
        notes: [
          "Chief Executive Officer and Executive Director",
          "Hung Fook Tong Group Holdings Limited",
        ],
      },
      {
        portrait: "boardmembers/member14.png",
        title: "Joyce Tam",
        subtitle: "",
        notes: ["Executive Director", "Goldman Sachs (Asia) L.L.C."],
      },
      {
        portrait: "boardmembers/member15.png",
        title: "James Wong",
        subtitle: "",
        notes: ["Chief Executive Officer", "Kwoon Chung Bus Holdings Limited"],
      },
      {
        portrait: "boardmembers/member16.png",
        title: "Jason Wong, JP",
        subtitle: "Chairman of Marketing and Business Development Committee",
        notes: ["General Manager", "Sin Ma Tours Limited"],
      },
      {
        portrait: "boardmembers/member17.png",
        title: "Simon Wong, BBS, JP",
        subtitle: "",
        notes: ["Chairman and CEO", "LH Group"],
      },
      {
        portrait: "boardmembers/member18.png",
        title: "Sonia Cheng",
        subtitle: "",
        notes: ["Chief Executive Officer", "Rosewood Hotel Group "],
        info: "Appointment effective from 1 November 2020",
      },
      {
        portrait: "boardmembers/member19.png",
        title: "Vanessa Cheung",
        subtitle: "",
        notes: ["Group Managing Director", "Nan Fung Development Ltd"],
        info: "Appointment effective from 1 January 2021",
      },
      {
        portrait: "boardmembers/member20.png",
        title: "Dennis Chow",
        subtitle: "",
        notes: ["Chairman", "Deloitte China"],
        info: "Appointment effective from 1 August 2021",
      },
    ];
    this.ZhBoardMembers = [
      {
        portrait: "boardmembers/member01.png",
        title: "彭耀佳博士，GBS，JP",
        subtitle: "主席兼優質旅遊服務委員會主席",
        notes: ["怡和管理有限公司", "副行政總裁"],
      },
      {
        portrait: "boardmembers/member02.png",
        title: "沈鳳君，JP",
        subtitle: "副主席",
        notes: ["香港特別行政區政府", "商務及經濟發展局", "旅遊事務專員"],
      },
      {
        portrait: "boardmembers/member03.png",
        title: "陳樂信，SC",
        subtitle: "",
        notes: ["Temple Chambers", "資深大律師"],
      },
      {
        portrait: "boardmembers/member04.png",
        title: "方力申",
        subtitle: "",
        notes: ["香港游泳學校有限公司", "董事"],
      },
      {
        portrait: "boardmembers/member05.png",
        title: "方舜文",
        subtitle: "",
        notes: ["香港貿易發展局", "總裁"],
      },
      {
        portrait: "boardmembers/member06.png",
        title: "馮玉麟博士",
        subtitle: "",
        notes: ["新鴻基地產發展有限公司", "執行董事"],
      },
      {
        portrait: "boardmembers/member07.png",
        title: "禤惠儀",
        subtitle: "",
        notes: ["渣打銀行(香港)有限公司", "香港執行董事兼行政總裁"],
      },
      {
        portrait: "boardmembers/member08.png",
        title: "關淑華",
        subtitle: "",
        notes: [
          "帝盛酒店集團",
          "營業高級副總裁(香港及英國)",
          "營運總監(歐洲)",
          "蘭桂坊酒店@九如坊總經理",
        ],
        info: "任期由2020年7月19日起生效",
      },
      {
        portrait: "boardmembers/member09.png",
        title: "郭艷明",
        subtitle: "財務及編制委員會主席",
        notes: ["信報財經新聞有限公司", "總編輯"],
      },
      {
        portrait: "boardmembers/member10.png",
        title: "劉凱詩",
        subtitle: "",
        notes: ["國泰航空公司", "商務董事"],
        info: "任期由2020年8月16日起生效",
      },
      {
        portrait: "boardmembers/member11.png",
        title: "梁宏正，BBS，JP",
        subtitle: "產品及活動委員會主席",
        notes: ["新興織造廠有限公司", "董事"],
      },
      {
        portrait: "boardmembers/member12.png",
        title: "沈朝生",
        subtitle: "稽核委員會主席",
        notes: ["南華（快捷）旅行社有限公司", "執行董事"],
      },
      {
        portrait: "boardmembers/member13.png",
        title: "司徒永富",
        subtitle: "",
        notes: ["鴻福堂集團控股有限公司", "行政總裁兼執行董事"],
      },
      {
        portrait: "boardmembers/member14.png",
        title: "譚載怡",
        subtitle: "",
        notes: ["高盛(亞洲)有限責任公司", "執行董事"],
      },
      {
        portrait: "boardmembers/member15.png",
        title: "黃焯安",
        subtitle: "",
        notes: ["冠忠巴士集團有限公司", "行政總裁"],
      },
      {
        portrait: "boardmembers/member16.png",
        title: "黃進達，JP",
        subtitle: "市場推廣及業務發展委員會主席",
        notes: ["星馬旅行社有限公司", "總經理"],
      },
      {
        portrait: "boardmembers/member17.png",
        title: "黃傑龍，BBS，JP",
        subtitle: "",
        notes: ["叙福樓集團", "主席、行政總裁"],
      },
      {
        portrait: "boardmembers/member18.png",
        title: "鄭志雯",
        subtitle: "",
        notes: ["瑰麗酒店集團", "首席行政總裁"],
        info: "任期由2020年11月1日起生效",
      },
      {
        portrait: "boardmembers/member19.png",
        title: "張添琳",
        subtitle: "",
        notes: ["南豐發展有限公司", "董事總經理"],
        info: "任期由2021年1月1日起生效",
      },
      {
        portrait: "boardmembers/member20.png",
        title: "周志賢",
        subtitle: "",
        notes: ["德勤中國主席"],
        info: "任期由2021年8月1日起生效",
      },
    ];
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.bg-img {
  // background-image: url(../assets/boardmembers/bg_pattern.jpg);
  // background-size: cover;
  background-image: linear-gradient(#fafafa, #e4e4e4);
}
.notes {
  font-size: 0.8rem;
}
</style>
